import * as React from "react";
import { useState, useEffect } from "react";
import useLocation from "routing/useLocation";
import useLicenseCheck from "license/useLicenseCheck";
import withIsPermitted from "forwarder/util/withIsPermitted";
import Permissions from "security-app/Permissions";
import StringUtils from "util/StringUtils";
import { DocumentTitle, Spinner } from "components/common";
import useSearchVersionCheck from "hooks/useSearchVersionCheck";
import SecurityTeaserPage from "components/security/teaser/SecurityPage";
const REQUIRED_PERMISSIONS = [Permissions.securityApp.read];
const SecurityLayout = ({ children }) => {
  const [title, setTitle] = useState("security");
  const {
    security: { isValid: isValidSecurityLicense }
  } = useLicenseCheck();
  const location = useLocation();
  const { isLoading: isLoadingSearchVersion } = useSearchVersionCheck("opensearch");
  useEffect(() => {
    const searchPattern = /\/security\//;
    const newLocation = location.pathname.replace(searchPattern, "");
    if (newLocation === "/security") {
      setTitle("Security");
    } else {
      setTitle(StringUtils.toTitleCase(newLocation.split("/")[0], "-"));
    }
  }, [location]);
  if (isLoadingSearchVersion) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading security module ..." });
  }
  if (!isValidSecurityLicense) {
    return /* @__PURE__ */ React.createElement(SecurityTeaserPage, null);
  }
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title }, children);
};
export default withIsPermitted(SecurityLayout, REQUIRED_PERMISSIONS);
